var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortUpDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_16px",
    clipPath: "url(#clip0_6269_5718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line 202 (Stroke)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99957 3L4.99958 15L2.99958 15L2.99958 3L4.99957 3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99159 0.93175L0.457519 4.46582L1.8717 5.88006L3.99159 3.76018L6.11153 5.88012L7.52574 4.4659L3.99159 0.93175Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line 202 (Stroke)_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9833 13L10.9833 1L12.9833 1L12.9833 13L10.9833 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9913 15.0682L15.5254 11.5342L14.1112 10.1199L11.9913 12.2398L9.87138 10.1199L8.45717 11.5341L11.9913 15.0682Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6269_5718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpDown);
export default __webpack_public_path__ + "static/media/sort-up-down.0c474ea5d13964ed7ef0999a30662ad3.svg";
export { ForwardRef as ReactComponent };